import { Control, FieldValues, Path, useController } from "react-hook-form";
import { Input } from "..";


type FormInputProps<T extends FieldValues> = {
  name: Path<T>;
  control: Control<T>;
  error?: string | null;
  valueAsNumber?: boolean;
} & Omit<React.ComponentProps<typeof Input>, "value" | "onChange" | "error">;

export function FormInput<T extends FieldValues>({
  name,
  control,
  error,
  valueAsNumber,
  ...rest
}: FormInputProps<T>) {
  const { field, fieldState } = useController({ name, control });

  const isNumeric = valueAsNumber || rest.type === "number";
  const handleChange = isNumeric
    ? (val: string) => field.onChange(val === "" ? "" : Number(val))
    : field.onChange;

  return (
    <Input
      {...rest}
      value={field.value ?? ""}
      onChange={handleChange}
      ref={field.ref}
      error={error ?? fieldState.error?.message ?? null}
    />
  );
}